module.exports = "/shared/img/button-up.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/button-up.png
// module id = 434
// module chunks = 13